import { useNavigate } from "react-router-dom";

function SecondSection() {
  const navigate = useNavigate();
  return (
    <div className="second">
      <div className="second-con">
        <img src={require("../public/hero (3).jpg")} />
        <div>
          <h1 className="title">About Our Special Orders</h1>
          <br />
          <p className="subtitle">
            We curate libraries for homes using detailed information about the ages of the children and how inquisitive each child is, so we can properly curate a perfect library for everyone in the house. We also update school libraries and curate complete libraries for new schools.
          </p>
          <br />
          <section>
            <button className="btn">Start shoping</button>
            <button className="btn">Make order</button>
          </section>
        </div>
      </div>
    </div>
  );
}

export default SecondSection;
